<div class="cartesiano">
  <div class="cartesiano__marco">
    <div class="cartesiano__marco__origin">
      <div class="cartesiano__marco__origin__point" style="left: {{point1?.lat()}}px; top: {{point1?.lng()}}px;">

      </div>
      <div class="cartesiano__marco__origin__point" style="left: {{point2?.lat()}}px; top: {{point2?.lng()}}px;">

      </div>
      <div class=" cartesiano__marco__origin__point cartesiano__marco__origin__point--final" style="left: {{pointFinal?.lat()}}px; top: {{pointFinal?.lng()}}px;">

      </div>
    </div>
  </div>
</div>
